import type { SSEOptions } from '../request';

export async function handleSSE<T>(
  url: string,
  method: string,
  data: Record<string, any>,
  headers: HeadersInit,
  options: SSEOptions
): Promise<void> {
  const res = await fetch(url, {
    method,
    headers: {
      ...headers,
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    signal: options.signal,
  });

  if (!res.ok || !res.body) {
    throw new Error(`SSE failed: ${res.status}`);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';

  try {
    while (true) {
      // Check if the request was aborted
      if (options.signal?.aborted) {
        throw new DOMException('Request aborted', 'AbortError');
      }

      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      let lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed.startsWith('data:')) continue;

        const payload = trimmed.replace(/^data:\s*/, '');

        if (!payload) continue;
        if (payload === '[DONE]') {
          options.onDone?.();
          return;
        }

        try {
          options.onMessage?.(payload);
        } catch (err) {
          options.onError?.(err);
        }
      }
    }

    if (buffer) {
      const trimmed = buffer.trim();
      if (trimmed.startsWith('data:')) {
        const payload = trimmed.replace(/^data:\s*/, '');
        if (payload && payload !== '[DONE]') {
          options.onMessage?.(payload);
        }
      }
    }

    options.onDone?.();
  } catch (err) {
    options.onError?.(err);
  }
}
